import { Suspense, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute, PublicRoute } from '@/app/providers/Router';
import { PageLoader } from '@/shared/ui/Loader';
import { routeConfig, TypeRouteConfig } from '../../config/routeConfig';

export const RouterProvider = () => {
  const routesWithLayout = useCallback((route: TypeRouteConfig) => {
    let WrapperRoute = PublicRoute;

    if (route.isAuth) {
      WrapperRoute = ProtectedRoute;
    }

    const element = (
      <WrapperRoute>
        <Suspense fallback={<PageLoader />}>{route.element}</Suspense>
      </WrapperRoute>
    );

    return <Route key={route.path} path={route.path} element={element} />;
  }, []);

  return <Routes>{routeConfig.map(routesWithLayout)}</Routes>;
};
